import { render } from "./FontFamily.vue?vue&type=template&id=1a00d96d&scoped=true"
import script from "./FontFamily.vue?vue&type=script&lang=ts"
export * from "./FontFamily.vue?vue&type=script&lang=ts"

import "./FontFamily.vue?vue&type=style&index=0&id=1a00d96d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1a00d96d"

export default script